import { ProductTileModel } from "@api/mappers/products.mapper";

import {
    getPageInfo,
    getUserInfo,
} from "@services/tracking/trackers/pageImpressionTracker";
import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { EventTypes } from "@services/tracking/types/eventTypes";

import { CartItemModel } from "@redux/modules/api/data/cart/@types/cart.model";

import { ECommerceModel } from "@components/Product/ECommerce/eCommerce.types";

import {
    mapCartItemFromCartItemModel,
    mapCartItemFromECommerceModel,
    mapCartItemFromProductTileModel,
} from "@factory/Tracking/cart.model";

import { CartProductTrackingInfo } from "../types/trackingInfo/cartProductTrackingInfo";

const trackUpdateCartItemImpression = (
    cartItem: CartItemModel,
    quantityDelta?: number,
) => {
    const isAddToCart = quantityDelta && quantityDelta > 0;
    const quantity = isAddToCart ? quantityDelta : quantityDelta! * -1;
    const eventName = isAddToCart
        ? EventTypes.AddToCartImpression
        : EventTypes.RemoveFromCartImpression;

    trackCartChangeImpression(
        eventName,
        mapCartItemFromCartItemModel(cartItem, quantity),
    );
};

const trackRemoveFromCartImpression = (
    cartItem: CartItemModel,
    quantity: number,
) => {
    trackCartChangeImpression(
        EventTypes.RemoveFromCartImpression,
        mapCartItemFromCartItemModel(cartItem, quantity),
    );
};

const trackAddToCartImpression = (
    ecommerceModel: ECommerceModel | ProductTileModel,
    quantity: number,
) => {
    if ((ecommerceModel as ECommerceModel).product) {
        return trackCartChangeImpression(
            EventTypes.AddToCartImpression,
            mapCartItemFromECommerceModel(
                ecommerceModel as ECommerceModel,
                quantity,
            ),
        );
    }

    trackCartChangeImpression(
        EventTypes.AddToCartImpression,
        mapCartItemFromProductTileModel(
            ecommerceModel as ProductTileModel,
            quantity,
        ),
    );
};

const trackCartChangeImpression = (
    eventName: string,
    impression: CartProductTrackingInfo,
) => {
    const event: TypedAnalyticsEvent<CartProductTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: impression,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export {
    trackUpdateCartItemImpression,
    trackRemoveFromCartImpression,
    trackAddToCartImpression,
};
